import React, { InputHTMLAttributes } from 'react';

import { Container, IconContainer } from './styles';

type RadioProps = InputHTMLAttributes<HTMLInputElement>;

const Radio: React.FC<RadioProps> = ({ children, style, ...rest }) => {
  return (
    <Container style={style}>
      <input type="radio" {...rest} />
      <IconContainer>
        <span />
      </IconContainer>
      {children}
    </Container>
  );
};

export default Radio;
